import PubSub from 'pubsub-js';

const NOTIFICATION_EVENT = 'notification-event';

export const NOTIFICATION_TYPES = {
  JOIN: 'join',
  LEAVE: 'leave',
  START_TALK: 'start_talk',
  STOP_TALK: 'stop_talk',
};

/**
 *  EVENT PUB-SUB SECTION
 * */
export const emitNotification = data => {
  PubSub.publish(NOTIFICATION_EVENT, data);
};

export const emitPersistenceMessage = data => {
  PubSub.publish(NOTIFICATION_EVENT, { ...data, persistence: true });
};

export const subscribeToNotification = cb => {
  const token = PubSub.subscribe(NOTIFICATION_EVENT, (msg, data) => cb(data));

  return () => {
    PubSub.unsubscribe(token);
  };
};

/**
 *  NOTIFICATION MESSAGES TEXT BUILDER
 * */
export function makeNotificationBuilder(formatMessage) {
  return ({ type, name }) => {
    switch (type) {
      case NOTIFICATION_TYPES.JOIN: {
        const id = 'virtualVisit.room.join';
        return formatMessage({ id }, { name });
      }
      case NOTIFICATION_TYPES.LEAVE: {
        const id = 'virtualVisit.room.leave';
        return formatMessage({ id }, { name });
      }
      case NOTIFICATION_TYPES.START_TALK: {
        const id = 'virtualVisit.room.isTalking';
        return formatMessage({ id }, { name });
      }
      case NOTIFICATION_TYPES.STOP_TALK: {
        return '';
      }

      default: {
        return '';
      }
    }
  };
}

const FORCE_UPDATE_EVENT = 'force-update';

export const emitForceUpdate = () => {
  PubSub.publish(FORCE_UPDATE_EVENT);
};

export const subscribeToForceUpdate = cb => {
  const token = PubSub.subscribe(FORCE_UPDATE_EVENT, cb);

  return () => {
    PubSub.unsubscribe(token);
  };
};



// WEBPACK FOOTER //
// ./src/redux/opentok/helpers/notifications.js